module.exports = "/_next/static/images/dbe9110bfd212ac301364625d10e6b1c-rewards-smiles@0.75x.png";